/** Persists #vertical-menu-btn (hamburger) sidebar state across route changes — each route remounts Layout. */
export const VERTICAL_MENU_COLLAPSED_KEY = "rsVerticalMenuCollapsed"
export const VERTICAL_MENU_MOBILE_OPEN_KEY = "rsVerticalMenuMobileOpen"

/**
 * Applies session-stored main navigation open/closed state to document.body.
 * Desktop: collapsed (icon bar) when stored "1" or unset; expanded when stored "0".
 * Mobile: open only when stored "1".
 */
export function applyStoredVerticalMenuState() {
  const body = document.body
  if (!body) return

  const wide = window.innerWidth > 998
  if (wide) {
    const stored = sessionStorage.getItem(VERTICAL_MENU_COLLAPSED_KEY)
    const collapsed = stored !== "0"
    if (collapsed) {
      body.classList.add("vertical-collpsed")
      body.classList.add("sidebar-enable")
    } else {
      body.classList.remove("vertical-collpsed")
      body.classList.remove("sidebar-enable")
    }
  } else {
    const stored = sessionStorage.getItem(VERTICAL_MENU_MOBILE_OPEN_KEY)
    body.classList.remove("vertical-collpsed")
    if (stored === "1") body.classList.add("sidebar-enable")
    else body.classList.remove("sidebar-enable")
  }
}

export function persistVerticalMenuToggle() {
  const body = document.body
  if (!body) return

  if (window.innerWidth <= 998) {
    sessionStorage.setItem(
      VERTICAL_MENU_MOBILE_OPEN_KEY,
      body.classList.contains("sidebar-enable") ? "1" : "0"
    )
  } else {
    sessionStorage.setItem(
      VERTICAL_MENU_COLLAPSED_KEY,
      body.classList.contains("vertical-collpsed") ? "1" : "0"
    )
  }
}
